import { createContext,useEffect,useReducer } from "react";

export const CustomerAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'CUSTOMER_LOGIN':
        return {customer: action.payload}

        case 'CUSTOMER_LOGOUT':
            return {
                customer:null,
            };
        
            case 'AUTH_READY':
                return { ...state, customer: action.payload, loading: false };

        default:
            return state;    
    }
}

export const CustomerAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        customer:null,
        loading: true,
    });

    useEffect(()=>{
        const customer = JSON.parse(localStorage.getItem('customer'));
        //if(customer){
            dispatch({type:'AUTH_READY', payload:customer});
      //  }

    },[]);

    return (
        <CustomerAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </CustomerAuthContext.Provider>
    )
}